import { useNavigate } from 'react-router-dom';
import { IconButton, Stack, Typography } from '@mui/material';
import { Add } from '@mui/icons-material';
import TemplateGallery from '@/features/template-gallery/TemplateGallery';
import { deleteTemplate, fetchTemplates } from '@/features/admin/templates/slice';
import { useConfirmation, useAppDispatch } from '@/hooks';
import { Template } from '@/types';
import { useEffect } from 'react';
import routes from '@/constants/routes';

const Templates = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [renderConfirmationDialog, confirmTemplateDeletion] = useConfirmation({
    title: 'Eliminar',
    message: 'Desea eliminar el menú',
    dispatcher: deleteTemplate,
  });

  useEffect(() => {
    dispatch(fetchTemplates());
  }, [])

  const onDelete = (templateId: Template['id']) => {
    confirmTemplateDeletion({ templateId });
  };

  const onEdit = (templateId: Template['id']) => {
    navigate(
      routes.templates.edit
        .replace(':templateId', templateId)
        .replace(':organizationId', 'ACME')
    );
  };

  return (
    <Stack padding={4} spacing={2}>
      <Typography variant="h1">Plantillas</Typography>
      <Stack alignItems={'center'}>
        <IconButton size="large" onClick={() => navigate('/plantillas/crear')}>
          <Add fontSize="large" />
        </IconButton>
      </Stack>
      <TemplateGallery type={'edit'} onEdit={onEdit} onDelete={onDelete} />
      {renderConfirmationDialog()}
    </Stack>
  );
};

export default Templates;
